import { useContext } from "react";
import { AppContext } from "../context/AppContext";
import { useFeatureFlagContext } from "./useFeatureFlagContext";

export const useShowAICoPilot = (): boolean => {
  const { venueGroupConfig } = useContext(AppContext);
  const { isFlagEnabled } = useFeatureFlagContext();
  return (
    isFlagEnabled("showAICoPilot") && venueGroupConfig?.product_tier === "evo"
  );
};
